export const saveAsFile = (file: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(file);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = filename;
  anchor.target = '_blank';
  anchor.rel = 'noopener';

  document.body.appendChild(anchor);

  anchor.click();

  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
};

/**
 * Read file
 */
export const readFile = (file: File): Promise<Uint8Array<ArrayBuffer>> =>
  new Promise<Uint8Array<ArrayBuffer>>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target?.result && typeof event.target.result !== 'string') {
        const fileContent: Uint8Array<ArrayBuffer> = new Uint8Array(event.target.result);
        resolve(fileContent);
      } else {
        reject(new Error('The file could not be read.'));
      }
    };

    reader.onerror = () => {
      const error = JSON.stringify(reader.error);

      reject(new Error(`FileReader error: ${error}`));
    };

    reader.readAsArrayBuffer(file);
  });
